import React, { useState } from 'react';
import axios from 'axios'
import {
  Box,
  Card,
  CardBody,
  Text,
  HStack,
  Badge,
  Divider,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  Heading,
  SimpleGrid,
  List,
  ListItem,
  Stack,
  Select,
  Textarea,
} from '@chakra-ui/react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { BsThreeDotsVertical, BsChatSquareQuote } from 'react-icons/bs';
import { RiFileShredLine, RiRestartLine } from 'react-icons/ri';

import { useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import { FaExclamationCircle } from 'react-icons/fa';




const EditRequestModal = ({ isOpen, onClose, onRequestEdit }) => {
  const [editReason, setEditReason] = useState('');
  const reasonOptions = [
    'Spelling/Grammar Error',
    'Content Modification',
    'Formatting/Style Change',
    'Other',
  ];

  const handleEditReasonChange = (event) => {
    setEditReason(event.target.value);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Request Edit</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
        <VStack spacing={4} alignItems="center">
            <VStack bg="red.100" p={2} borderRadius="md" spacing={2} alignItems="center">
              <FaExclamationTriangle size={34} color="red" />
              <Text color="red.600" fontWeight="bold" padding={5}>
                Warning: You have only 1 edit request.Once requested, it cannot be changed/requested later.
              </Text>
            </VStack>
            <Text >Select a reason for the edit:</Text>
            <Select value={editReason} onChange={handleEditReasonChange}>
              {reasonOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Select>
            <Text  >Provide instructions for the edit:</Text>
            <Textarea
              placeholder="Enter instructions..."
              // value={editReason}
              // onChange={(e) => setEditReason(e.target.value)}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" mr={3} onClick={() => onRequestEdit(editReason)}>
            Confirm Edit Request
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const OrdersCard = ({ title, id, wordCount, status, colorModeValue, qnaStatus }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editRequested, setEditRequested] = useState(false);
  const [isEditRequestModalOpen, setIsEditRequestModalOpen] = useState(false);

  const order = { orderId: id };

  const navigate = useNavigate();

  const handleCardClick = () => {
    // setIsModalOpen(true);
    navigate(`/TrialDash/orderdetail`);

  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestEdit = (editReason) => {
    if (!editRequested) {
      setEditRequested(true);
      closeModal();
      closeEditRequestModal();

      const data = {
        orderId: "2229272",
        reasonCode: 'E101',
        reason: " random reason",
      };



      axios.post('http://localhost:3000/sop/order/edit',{data}, {withCredentials: true})
            .then((response) => {
              // Handle the response if needed
              console.log(response);
            })
            .catch((error) => {
              // Handle errors if the API call fails
              console.error('Error requesting edit:', error);
            });
    }
  };

  const openEditRequestModal = () => {
    setIsEditRequestModalOpen(true);
  };

  const closeEditRequestModal = () => {
    setIsEditRequestModalOpen(false);
  };



  return (
    <Box width="100%" cursor="pointer">
      <Card
      width="100%"
      _hover={{ boxShadow: 'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px' }}
      >
        <CardBody as={Link} to={{ pathname: "/TrialDash/orderdetail" }} state={{ order }}>
          <HStack width="100%" justifyContent="space-between">
            <Box>
              <Text fontWeight="bold" fontSize={{ base: 'lg', md: 'xl' }}>
                {title}
              </Text>
              <HStack height="20px" marginTop="10px" display={{ base: 'none', md: 'flex' }}>
                <Text fontSize="md">#Id {id}</Text>
                <Divider orientation="vertical" />
                <Text fontSize="md">{wordCount} Words</Text>
                <Divider orientation="vertical" />
                <Text fontSize="md">{status}</Text>
              </HStack>
            </Box>
            <HStack>
              {qnaStatus ? (
                 <Badge colorScheme="green" borderRadius="md" px={2} py={1} display="flex" alignItems="center">
                 <FaCheckCircle size={16} style={{ marginRight: '0.5rem' }} />
                 Done
               </Badge>
              ) : (
                <Badge colorScheme="red" borderRadius="md" px={2} py={1} display="flex" alignItems="center">
      <FaExclamationCircle size={16} style={{ marginRight: '0.5rem' }} />
      fill Q&A !!
    </Badge>
              )}
            </HStack>
            <HStack>
              <Flex justifyContent="center" mt={4}>
                <Popover placement="bottom" isLazy>
                  <PopoverTrigger>
                    <IconButton
                      aria-label="More server options"
                      icon={<BsThreeDotsVertical />}
                      variant="solid"
                      w="fit-content"
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                    />
                  </PopoverTrigger>
                  <PopoverContent
                    w="fit-content"
                    _focus={{ boxShadow: 'none' }}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                  >
                    <PopoverArrow />
                    <PopoverBody>
                      <Stack>
                        <Link to={{ pathname: "/TrialDash/orderdetail" }} state={{ order }}>
                          <Button
                            onClick={() => console.log("id" + id)}
                            w="194px"
                            variant="ghost"
                            rightIcon={<BsChatSquareQuote />}
                            justifyContent="space-between"
                            fontWeight="normal"
                            fontSize="sm"
                          >
                            View Order
                          </Button>
                        </Link>
                        <Link to="/TrialDash/stroage">
                          <Button
                            w="194px"
                            variant="ghost"
                            rightIcon={<BsChatSquareQuote />}
                            justifyContent="space-between"
                            fontWeight="normal"
                            fontSize="sm"
                          >
                            View Timeline
                          </Button>
                        </Link>

                        <Button
                          w="194px"
                          variant="ghost"
                          rightIcon={<RiFileShredLine />}
                          justifyContent="space-between"
                          fontWeight="normal"
                          fontSize="sm"
                        >
                          View Invoice
                        </Button>
                        <Button
                          w="194px"
                          variant="ghost"
                          rightIcon={<RiRestartLine />}
                          justifyContent="space-between"
                          fontWeight="normal"
                          colorScheme="red"
                          fontSize="sm"
                          onClick={openEditRequestModal}
                          isDisabled={editRequested}
                        >
                          Request Edit
                        </Button>
                      </Stack>
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
              </Flex>
            </HStack>
          </HStack>
        </CardBody>
      </Card>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Order Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              <Heading>{title}</Heading>
              <Text>ID: {id}</Text>
              <Text>Word Count: {wordCount}</Text>
              <Text>Status: {status}</Text>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={closeModal}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <EditRequestModal
        isOpen={isEditRequestModalOpen}
        onClose={closeEditRequestModal}
        onRequestEdit={handleRequestEdit}
      />
    </Box>
  );
};

export default OrdersCard;
